var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavMobileHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.92857 1.42857V7.14286H7.64286V1.42857H1.92857ZM0.5 0H1.92857H7.64286H9.07143V1.42857V7.14286V8.57143H7.64286H1.92857H0.5V7.14286V1.42857V0ZM1.92857 12.8571V18.5714H7.64286V12.8571H1.92857ZM0.5 11.4286H1.92857H7.64286H9.07143V12.8571V18.5714V20H7.64286H1.92857H0.5V18.5714V12.8571V11.4286ZM19.0714 1.42857H13.3571V7.14286H19.0714V1.42857ZM13.3571 0H19.0714H20.5V1.42857V7.14286V8.57143H19.0714H13.3571H11.9286V7.14286V1.42857V0H13.3571ZM13.3571 12.8571V18.5714H19.0714V12.8571H13.3571ZM11.9286 11.4286H13.3571H19.0714H20.5V12.8571V18.5714V20H19.0714H13.3571H11.9286V18.5714V12.8571V11.4286Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMobileHome);
export default __webpack_public_path__ + "static/media/nav-mobile-home.4d61a5fc583a65c50da677e6345aacb7.svg";
export { ForwardRef as ReactComponent };